import { Stopwatch as StopWatchIcon } from "assets/icons";
import { InformationSetting } from "components/settings";
import { WidgetType } from "types/Widget";

import { Stopwatch, StopwatchState } from "./Stopwatch";

export const StopwatchWidget: WidgetType<StopwatchState> = {
  name: "Stopwatch",
  component: Stopwatch,
  icon: StopWatchIcon,
  showOnToolbar: true,
  sizing: {
    minWidth: 96,
    minHeight: 72,
    minAspectRatio: 1,
    maxAspectRatio: 2,
  },
  defaultState: {
    currentTime: 0,
  },
  defaultSize: {
    aspectRatio: 2,
    widthPercentage: 20,
  },
  settings: {
    info: {
      editor: InformationSetting,
      info: {
        info: "Starts a timer that counts up. Useful for timing classroom activities.",
      },
    },
  },
};
